import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { withRouter, Redirect, Link } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import AppWrapper from "../Common/AppWrapper/index.jsx";
import { RenderInput } from "../Common/InputComponents/Inputs.jsx";
import Loading from "../Common/Misc/Loading";
import { TipAssayBatchUpload } from "../Common/Misc/Tooltips.jsx";
import { removeSpaces, joinSpaces } from "../../util/format";
import { validateCommercialIdArray } from "../../util/validations";
import { withStyles } from "@material-ui/core/styles";
import _ from "underscore";
import classNames from "classnames";
import * as assayActions from "../../actions/assays";
import "./AssayBatchUpload.scss";
import * as serverValidations from "../../i18n/en/server-side-validation-errors.json";

const styles = (theme) => ({
  progress: {
    marginLeft: theme.spacing(2),
  },
});

export class AssayBatchUpload extends Component {
  componentWillUnmount() {
    const { actions } = this.props;
    actions.clearValidatedCommercialIdList();
  }
  render() {
    const {
      formObj,
      classes,
      handleSubmit,
      pristine,
      submitting,
      actions,
      rejectedCommercializedId,
      pageLoading,
    } = this.props;
    const btnSubmitClass = classNames({
      "btn-submit float-right": !submitting,
      "btn-submit float-right btn-submitting": submitting,
    });

    return (
      <AppWrapper id="bulk-upload" pageTitle="Assay Bulk Upload">
        <div id="bg">
          <div id="bg-inner"></div>
        </div>
        {pageLoading && (
          <div className="container main-content">
            <div className="hero">
              <h1>Batch Upload Multiple Assays to "My Assays" Page</h1>
            </div>
            <div id="batch-form">
              <h3>Your assays are being processed</h3>
              <Loading isLoading={pageLoading} />
            </div>
          </div>
        )}
        {!pageLoading && (
          <div className="container main-content">
            <div className="hero">
              <h1>Batch Upload Multiple Assays to "My Assays" Page</h1>
            </div>

            <div id="batch-form">
              <div className="row">
                <div className="col align-self-center">
                  <div className="form-group">
                    <Field
                      name="commercializedIds"
                      className="form-control"
                      type="textArea"
                      rows="8"
                      placeholder="dHsaCP2500366, dHsaCP2500350, dHsaCPE5031596"
                      component={RenderInput}
                      label="Enter Bio-Rad Assay IDs separated by commas."
                      validate={[validateCommercialIdArray]}
                      normalize={removeSpaces}
                      onChange={() => actions.clearValidatedCommercialIdList()}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <button
                    type="button"
                    className={btnSubmitClass}
                    disabled={pristine || submitting}
                    onClick={handleSubmit}
                  >
                    {!submitting ? "SUBMIT" : "SUBMITTING"}
                    {submitting && (
                      <CircularProgress
                        className={classes.progress}
                        size={20}
                        thickness={4}
                      />
                    )}
                  </button>
                </div>
              </div>

              {rejectedCommercializedId &&
                !_.isEmpty(rejectedCommercializedId) && (
                  <div>
                    <span>
                      {
                        serverValidations.error.Target.BatchUpload
                          .NoCommercialIdMatch
                      }
                    </span>
                    <ul>
                      {rejectedCommercializedId &&
                        !_.isEmpty(rejectedCommercializedId) &&
                        _.map(rejectedCommercializedId, (id, index) => {
                          return (
                            <li className="form-error" key={index}>
                              {id}
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                )}
            </div>
          </div>
        )}
      </AppWrapper>
    );
  }
}

const onSubmit = (values, dispatch) => {
  const { commercializedIds } = values;
  const commercializedIdsArr = commercializedIds.split(",");
  dispatch(assayActions.batchAddToMyAssays(commercializedIdsArr));
  dispatch(actions.clearValidatedCommercialIdList());
};

const stateToProps = (state) => ({
  formObj: state.form["frmAssayBatchUpload"],
  initialValues: {},
  rejectedCommercializedId: state.assays.rejectedCommercializedId || [],
  pageLoading: (state.assays && state.assays.pageLoading) || false,
});

const dispatchToProps = (dispatch) => ({
  actions: bindActionCreators(assayActions, dispatch),
});

AssayBatchUpload = reduxForm({
  form: "frmAssayBatchUpload",
  enableReinitialize: true,
  onSubmit,
})(AssayBatchUpload);

AssayBatchUpload = withStyles(styles)(AssayBatchUpload);

export default AssayBatchUpload = withRouter(
  connect(stateToProps, dispatchToProps)(AssayBatchUpload)
);

AssayBatchUpload.propTypes = {
  state: PropTypes.object,
  match: PropTypes.object,
};
